import { IdAssetBundleGrounds } from "../assetBundles/IdAssetBundleGrounds";
var Sprite = PIXI.Sprite;
export var GetUnlockedGroundGraphicIso = function (data, baseSetup) {
    var sprite = Sprite.fromFrame(IdAssetBundleGrounds.ground_dirt);
    // All building assets are positioned with them having anchor in bottom-center
    sprite.anchor.set(0.5, 1);
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetUnlockedGroundGraphicIso.ts
// module id = 2223
// module chunks = 3